import searchAtomPair, { SearchParams } from 'atoms/search-atom';
import {
  GeologicIntervalTypeCurveQueryResponse,
  GeologicIntervalQueryResponse,
  TypeCurveHeaderQueryResponse,
} from 'types/api-responses';
import {
  createDeleteAtom,
  createMutationAtom,
} from 'atoms/create-resource-atom';

interface GeologicIntervalTypeCurveQueryParams extends SearchParams {
  basin_name?: string;
  geologic_interval?: string;
  as_of_date?: {
    from?: string;
    to?: string;
  };
}

export const createGeologicIntervalTypeCurvesSearchAtom = (
  pageSizePreference: number
) => {
  const params = new URLSearchParams(window.location.search);

  // Handle filter parameters
  const basinName = params.get('basin_name') || undefined;
  const geologicInterval = params.get('geologic_interval') || undefined;
  const asOfDateFrom = params.get('as_of_date_from') || undefined;
  const asOfDateTo = params.get('as_of_date_to') || undefined;

  return searchAtomPair<
    GeologicIntervalTypeCurveQueryResponse,
    GeologicIntervalTypeCurveQueryParams
  >('geologicIntervalTypeCurves', {
    page: parseInt(params.get('page') || '1', 10),
    pageSize: pageSizePreference,
    basin_name: basinName,
    geologic_interval: geologicInterval,
    as_of_date: {
      from: asOfDateFrom,
      to: asOfDateTo,
    },
  });
};

export const deleteGeologicIntervalTypeCurveAtom = createDeleteAtom();

export const createGeologicIntervalTypeCurvesAtom = createMutationAtom();

export const geologicIntervalsSearchAtom = searchAtomPair<
  GeologicIntervalQueryResponse,
  { basin_name?: string; paginated: boolean }
>({ href: '/queries/geologic_intervals' }, { paginated: false });

export const typeCurveHeadersSearchAtom = searchAtomPair<
  TypeCurveHeaderQueryResponse,
  { status?: string; basin?: string; paginated: boolean }
>({ href: '/queries/type_curve_headers' }, { paginated: false });
